import { useEffect, useRef, useState } from 'react';
import { LifeBuoy, X } from 'lucide-react';
import { playMessage } from '@ck/ui';
import { api } from './api';

interface Row { id: string; ticket: string; subject: string; unread: number; last_reply: string | null; last_staff: string | null }

/** Anywhere in the portal: a chime and a pop-up when support joins or replies. */
export function SupportWatch({ open }: { open: (chatId: string) => void }) {
  const last = useRef<Record<string, number> | null>(null);
  const [pop, setPop] = useState<Row | null>(null);
  useEffect(() => {
    let stop = false;
    const tick = async () => {
      try {
        const { chats } = await api.get<{ chats: Row[] }>('/v1/support/chats');
        if (stop) return;
        const prev = last.current;
        if (prev) {
          const grew = chats.find((c) => c.unread > (prev[c.id] ?? 0));
          if (grew) { playMessage(); setPop(grew); }
        }
        last.current = Object.fromEntries(chats.map((c) => [c.id, c.unread]));
      } catch { /* signed out or offline: try later */ }
    };
    void tick();
    const t = window.setInterval(tick, 6000);
    return () => { stop = true; clearInterval(t); };
  }, []);
  useEffect(() => { if (!pop) return; const t = setTimeout(() => setPop(null), 15_000); return () => clearTimeout(t); }, [pop]);
  if (!pop) return null;
  const joined = pop.last_reply && /joined the chat/.test(pop.last_reply);
  return (
    <div className="alarm" role="status">
      <button className="alarm-msg" onClick={() => { open(pop.id); setPop(null); }}>
        <b><LifeBuoy style={{ width: 15, height: 15, verticalAlign: '-2px', marginRight: 6 }} />{joined ? 'Support joined your chat' : `${pop.last_staff ?? 'Support'} replied`} · {pop.ticket}</b>
        <small>{pop.last_reply?.slice(0, 160) ?? pop.subject}</small>
        <span className="alarm-x" role="button" aria-label="Dismiss" onClick={(e) => { e.stopPropagation(); setPop(null); }}><X /></span>
      </button>
    </div>
  );
}
